import { useMutation } from '@tanstack/react-query';
import { useAuthContext } from '@/app/providers/AuthProvider';
import type { LoginRequestDto } from '../api/auth.dto';

export function useLoginMutation() {
  const { login } = useAuthContext();

  return useMutation({
    mutationFn: async (credentials: LoginRequestDto) => {
      await login(credentials);
    },
  });
}
